import React from 'react';
import ReactDOM from 'react-dom';
import { App } from '@/app/app';
import { Boot } from "@/background/store/Bootstore";
import { MediaHandler } from './media/MediaHandler';
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import sha256 from 'crypto-js/sha256';
import * as Base64Con from 'crypto-js/enc-base64';
import { LiveStore } from "@/background/store/LiveStore";
import './app/css/App.css';
class Main {
    constructor(mhandler, boot, liveStore) {
        this.mhandler = mhandler;
        this.boot = boot;
        this.liveStore = liveStore;
    }
    bootUp() {
        this.boot.bootup();
    }
}
LetrwingCrypto.set256HashGen((str) => {
    return new Promise((resolve, reject) => {
        const data = sha256(str);
        resolve(Base64Con.stringify(data));
    });
});
export const main = new Main(new MediaHandler(), new Boot(), LiveStore);
main.bootUp();
ReactDOM.render(React.createElement(App, null), document.getElementById('root'));
